/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const {
  values: { sm, md, lg, xl, xxl, x3l, x4l, x5l, x6l },
} = breakpoints;

const SM = `@media (min-width: ${sm}px)`;
const MD = `@media (min-width: ${md}px)`;
const LG = `@media (min-width: ${lg}px)`;
const XL = `@media (min-width: ${xl}px)`;
const XXL = `@media (min-width: ${xxl}px)`;
const X3L = `@media (min-width: ${x3l}px)`;
const X4L = `@media (min-width: ${x4l}px)`;
const X5L = `@media (min-width: ${x5l}px)`;
const X6L = `@media (min-width: ${x6l}px)`;

const sharedClasses = {
  paddingRight: `${pxToRem(24)} !important`,
  paddingLeft: `${pxToRem(24)} !important`,
  marginRight: "auto !important",
  marginLeft: "auto !important",
  width: "100% !important",
  position: "relative",
};

const container = {
  [SM]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "540px !important",
    },
  },
  [MD]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "720px !important",
    },
  },
  [LG]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "960px !important",
    },
  },
  [XL]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "1140px !important",
    },
  },
  [XXL]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "1340px !important",
    },
  },
  [X3L]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "1540px !important",
    },
  },
  [X4L]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "1740px !important",
    },
  },
  [X5L]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "2020px !important",
    },
  },
  [X6L]: {
    ".MuiContainer-root": {
      ...sharedClasses,
      maxWidth: "2300px !important",
    },
  },
};

export default container;
